import { useEffect, useMemo, useRef, useState } from "react";

interface Position {
  id: string;
  title: string;
  period: string;
  duration: string;
  responsibilities: string[];
  achievements: string[];
}

interface Company {
  id: string;
  name: string;
  positions: Position[];
}

const workExperience: Company[] = [
  {
    id: "geropharm",
    name: "Герофарм",
    positions: [
      {
        id: "geropharm-head",
        title: "Руководитель отдела разработки",
        period: "2021 - настоящее время",
        duration: "4 года 7 месяцев",
        achievements: [
          "Опробовать и закрепить методы TDD",
          'Подготовить, реализовать и закончить несколько проектов калибра "Одна бизнес функция - одно приложение API+Клиент".',
          "Реализовать ПО для интеграции с оборудованием для маркировки ЛП и организовать процесс работы с ним.",
          "Внедрить в компанию практику работы с контейнеризацией",
          "Разбить MES на микросервисы.",
          "Наладить CI/CD для работы контейнерами.",
          "Расширить интеграцию маркировки до БАДов",
          "Расширить интеграцию маркировки до ИС других стран ЕАЭС а также с контрактными производителями из стран за пределами ЕАЭС.",
          "Реализовать решение по работе систем компании с обезличенными ЭЦП.",
          "Опробовать автоматизацию тестирования UI на базе Каталон студии. К сожалению из-за санкций не успел внедрить.",
        ],
        responsibilities: [],
      },
      {
        id: "geropharm-team-lead",
        title: "Руководитель группы разработки",
        period: "2018 - 2021",
        duration: "3 года",
        achievements: [
          "Начать в роли пионера работу над маркировкой ЛП для будущего Честного знака.",
          "Написать ряд чат-ботов для работы с маркированной продукцией и для согласования заявок ERP из мессенджеров",
          "Написать приложения для складских терминалов на Android. Native Java для работы с маркированной продукцией.",
          "Развить проект интеграционного приложения цехов с ERP до полноценной MES системы. Также добавилась полная интеграция с ИС МДЛП и ИС СУЗ (обе от Честного знака).",
          "Внедрить инфраструктурную платформу Gitlab. Смигрировать проекты и кодовую базу на него с TFS. Наладить методологию работы и цикл разработки и проемки кода. Наладить CI/CD c автоматическим выпуском разработческих сред под ветки разработчиков.",
          "Внедрить React как основную технологию для разработки фронта, а также найти и доработать инструменты и методы деплоя React-приложений на SharePoint без деплоя пакетов.",
          "Сделать новую ССД, более платформанезависимой: отвязать от Рабочих Процессов  и других сущностей системы компонент SharePoint. React+RestAPI+ShpTimerJobs",
        ],
        responsibilities: [],
      },
      {
        id: "geropharm-senior",
        title: "Старший разработчик",
        period: "2016 - 2017",
        duration: "1 год 2 месяца",
        achievements: [
          "Придумать и отладить программу стажировки для поиска молодых программистов",
          "Перевести всю кодовую базу JavaScript на TypeScript, включая проект на WinJS, а также практически полностью убрать JQuery.",
          "Разобраться с ADFS 1.0 во времена полного отсутствия документации по нему, вывел методики работы с ним для SharePoint и ASP.Net MVC приложений, написал компоненты для бесшофной работы порталов с ADFS и запустил на компанию для единого SSO.",
          "Сделать 2 новых проекта:",
          "Миграция чужого легаси приложения для работы с гос торгами с php на asp.net MVC+Razor",
          "Поточное сканирование, распознание и сортировка первичной документации по наклейкам с штрих-кодами и позиционными метками. C#/F#+openCV.",
        ],
        responsibilities: [],
      },
      {
        id: "geropharm-developer",
        title: "Разработчик",
        period: "2015 - 2016",
        duration: "1 год 6 месяцев",
        achievements: [
          "Отладить и донастроить фермы SharePoint.",
          "Написать пакет командлетов для PowerShell, ускоривший деплой и отладку компонент в среднем в 5 раз (да, прямо замерял).",
          "Закрыть технический долг по портальным компонентам. Закончить ССД на базе SharePoint в том виде в котором его задумал мой предшественник.",
          "Организовать центральный место хранения кода компании и методику работы с ним.",
          "Организовать тестовую (LiveCopy) и разработческую среды для работы более контролируемой разработки и сопровождения изменений.",

          "Написать 2 новых проекта с нуля.",
          "Интеграционное приложение для оперативного получения данных с цехов от персонала и от SCADA в ERP Axapta. Backend asp.net mvc api, 2 фронта: UWP на WinJS и Веб-сайт ASP.Net MVC с компонентами Razor.",
          "Второй система согласования и пролонгации доверенностей на базе наборов документов SharePoint.",
        ],
        responsibilities: [
          "Сопровождение и доработка SharePoint ферм и доработка отдельных компонентов",
          "Разработка и сопровождение внутренних веб-приложений на ASP.NET MVC и Web API",
          "Разработка и сопровождение интеграционных решений на базе SSIS и кастомных сервисов на C#",
        ],
      },
    ],
  },
  {
    id: "ittilan",
    name: "Иттилан",
    positions: [
      {
        id: "ittilan-senior",
        title: "Старший разработчик",
        period: "2014 - 2015",
        duration: "1 год",
        achievements: [
          "Успешно закрыть технические долги предыдущей команды",
          "Стартовать новые проекты и часть успешно закрыть",
          "Вывести несколько методов для ускорения и упрощения контроля разработки компонент для SharePoint",
          "Инициировать и начать внедрение в рабочий процесс инструментов TFS 2013 и devops практик, а также практик code review и парного программирования",
        ],
        responsibilities: [
          "Оценка проектных работ и работ поддержки",
          "Встречи с заказчиками для уточнения требований и обсуждения решений",
          "Решение по архитектуре и реализации проектов разработки",
          "Руководство разработки, проведение code review",
          "Работа в проектах по разработке индивидуальных порталов, отдельных модулей орг.структуры, бронирования переговорных через SharePoint портал с интеграцией с MS Exchange и базы знаний с живым поиском и статистикой использования и наполнения",
          "Обучение и курирование младших сотрудников",
        ],
      },
      {
        id: "ittilan-support-dev",
        title: "Разработчик отдела технической поддержки",
        period: "2013 - 2014",
        duration: "9 месяцев",
        achievements: [
          "Обучил двух новых разработчиков",
          "Улучшил отношения заказчиков с отделом тех. поддержки, что привело к увеличению количества договоров платной поддержки на сопровождение и развитию продуктов компании",
          "Получил опыт поднятия с нуля упавшей боевой фермы",
          "Совместно с коллегами вывел отдел поддержки на самоокупаемость, а затем и прибыль",
        ],
        responsibilities: [
          "Решение инцидентов, требующих исправления, настройки и доработки продуктов компании (компоненты SharePoint 2010, 2013 и online и приложения ASP.NET, дорабатывал контролы, веб-сервисы, http-модули и т.д., с завидной регулярностью поднимал и чинил службу-приложение синхронизации SP, а также писал нестандартные методы синхронизации с AD);",
          "Обучение младших сотрудников",
          "Консультация проектных команд разработчиков для более эффективной работы и дальнейшей поддержки решений",
        ],
      },
      {
        id: "ittilan-junior-support",
        title: "Младший разработчик отдела технической поддержки",
        period: "2012 - 2013",
        duration: "10 месяцев",
        responsibilities: [
          "Решение инцидентов требующих исправления, настройки или доработки продуктов компании - компоненты MS SharePoint 2010, Office и SQL.",
          "Помощь в тестировании новых функций и исправлений",
        ],
        achievements: [
          "Изучил основы работы платформы .Net в веб-приложениях ASP.NET, сервера веб-приложений IIS, powershell, объектную модель и компоненты SharePoint, javascript COM и jquery надстройки над ней, XSL, а также ввел ряд принципов работы для более легкого использования и понимания XSL-скриптов для разработчиков.",
          "Удалось использовать опыт предыдущей работы (типографии) для предварительной прорисовки макетов, интерфейсов и наглядных разъяснений, инструкций.",
        ],
      },
    ],
  },
  {
    id: "education",
    name: "Образование",
    positions: [
      {
        id: "university-graduation",
        title: "Окончил университет",
        period: "2008 - 2012",
        duration: "",
        achievements: [],
        responsibilities: [],
      },
    ],
  },
];

const FullCVPage = () => {
  const [activeSection, setActiveSection] = useState<string>("geropharm-head");
  const leftScrollRef = useRef<HTMLDivElement | null>(null);

  const allPositions = useMemo(
    () => workExperience.flatMap((company) => company.positions),
    [],
  );

  useEffect(() => {
    const root = leftScrollRef.current;
    if (!root) return;

    const elements = allPositions
      .map((position) => document.getElementById(position.id))
      .filter((el): el is HTMLElement => el !== null);

    const observer = new IntersectionObserver(
      (entries) => {
        const visibleEntries = entries
          .filter((entry) => entry.isIntersecting)
          .sort(
            (a, b) =>
              Math.abs(a.boundingClientRect.top) -
              Math.abs(b.boundingClientRect.top),
          );

        if (visibleEntries.length > 0) {
          const currentId = visibleEntries[0].target.id;
          setActiveSection(currentId);
        }
      },
      {
        root,
        threshold: 0,
        rootMargin: "0px 0px -80% 0px",
      },
    );

    elements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, [allPositions]);

  const scrollToSection = (sectionId: string) => {
    const container = leftScrollRef.current;
    const element = document.getElementById(sectionId);

    if (!container || !element) return;

    const containerRect = container.getBoundingClientRect();
    const elementRect = element.getBoundingClientRect();

    const top =
      container.scrollTop + (elementRect.top - containerRect.top) - 20;

    container.scrollTo({
      top,
      behavior: "smooth",
    });
  };

  return (
    <div className="relative left-[20px] md:left-[120px] flex h-full min-h-0 md:w-[750px] overflow-hidden bg-white">
      {/* Левая колонка — единственный scroll container */}
      <div className="flex min-h-0 max-w-[620px] flex-1 flex-col overflow-hidden">
        <div className="relative flex-1 min-h-0 overflow-hidden">
          <div
            ref={leftScrollRef}
            className="h-full overflow-y-auto px-[10px] pb-[150px] pt-[20px]"
          >
            <div className="flex w-[340px] md:w-[550px] flex-col">
              {workExperience.map((company) =>
                company.positions.map((position) => {
                  const globalIndex = allPositions.findIndex(
                    (p) => p.id === position.id,
                  );
                  const isLastOverall = globalIndex === allPositions.length - 1;

                  let intermediateYears: number[] = [];
                  if (!isLastOverall) {
                    const currentStartYear = parseInt(
                      position.period.split(" - ")[1],
                    );
                    const nextPosition = allPositions[globalIndex + 1];
                    const nextStartYear = parseInt(
                      nextPosition.period.split(" - ")[1],
                    );

                    if (!isNaN(currentStartYear) && !isNaN(nextStartYear)) {
                      for (
                        let year = currentStartYear;
                        year > nextStartYear;
                        year--
                      ) {
                        intermediateYears.push(year);
                      }
                    } else if (!isNaN(nextStartYear)) {
                      const currentYear = new Date().getFullYear();
                      for (
                        let year = currentYear;
                        year > nextStartYear;
                        year--
                      ) {
                        intermediateYears.push(year);
                      }
                    }
                  }

                  return (
                    <section
                      key={position.id}
                      id={position.id}
                      className="relative flex gap-[15px] scroll-mt-[20px]"
                    >
                      {/* Timeline */}
                      <div className="relative flex w-[60px] shrink-0 flex-col items-center pt-[8px]">
                        <div className="z-10 h-[12px] w-[12px] shrink-0 rounded-full border-[3px] border-white bg-[#334155] ring-2 ring-[#334155]" />

                        {!isLastOverall && (
                          <div className="relative mt-[4px] flex min-h-[100px] flex-1 flex-col items-center justify-evenly">
                            <div className="absolute inset-0 left-1/2 w-[2px] -translate-x-1/2 bg-[#cbd5e1]" />

                            {intermediateYears.map((year) => (
                              <div
                                key={year}
                                className="relative z-10 flex items-center gap-[8px] pr-[53px]"
                              >
                                <div className="w-[45px] text-right font-['Bitter',sans-serif] text-[12px] font-medium text-[#94a3b8]">
                                  {year}
                                </div>
                                <div className="h-[2px] w-[6px] bg-[#94a3b8]" />
                              </div>
                            ))}
                          </div>
                        )}
                      </div>

                      {/* Date */}
                      <div className="flex w-[80px] shrink-0 flex-col pt-[3px] hidden sm:hidden md:flex">
                        <p className="font-['Bitter',sans-serif] text-[13px] font-normal text-[#64748b]">
                          {position.period.split(" - ")[1]}
                        </p>
                        <p className="font-['Bitter',sans-serif] text-[13px] font-normal text-[#64748b]">
                          {position.period.split(" - ")[0]}
                        </p>
                        <p className="mt-[2px] font-['Bitter',sans-serif] text-[11px] font-normal text-[#94a3b8]">
                          {position.duration}
                        </p>
                      </div>

                      {/* Content */}
                      <div className="flex flex-1 flex-col gap-[10px] pb-[40px] max-w-[260px] md:max-w-[350px]">
                        <div className="flex flex-col">
                          <p className="font-['Bitter',sans-serif] text-[20px] font-bold text-[#0f172a]">
                            {position.title}
                          </p>
                        </div>

                        {(position.responsibilities.length > 0 ||
                          position.achievements.length > 0) && (
                          <div className="font-['Inter',sans-serif] text-[12px] font-medium tracking-[-0.132px] text-[#334155]">
                            {position.responsibilities.length > 0 && (
                              <>
                                <p className="mb-0 leading-[1.5]">
                                  Обязанности:
                                </p>
                                <ul className="list-disc">
                                  {position.responsibilities.map(
                                    (responsibility, index) => (
                                      <li
                                        key={index}
                                        className="mb-0 ms-[18px]"
                                      >
                                        <span className="leading-[1.5]">
                                          {responsibility}
                                        </span>
                                      </li>
                                    ),
                                  )}
                                </ul>
                                <br />
                              </>
                            )}

                            {position.achievements.length > 0 && (
                              <>
                                <p className="mb-0 leading-[1.5]">
                                  Чего удалось достичь:
                                </p>
                                <ul className="list-disc">
                                  {position.achievements.map(
                                    (achievement, index) => (
                                      <li
                                        key={index}
                                        className="mb-0 ms-[18px]"
                                      >
                                        <span className="leading-[1.5]">
                                          {achievement}
                                        </span>
                                      </li>
                                    ),
                                  )}
                                </ul>
                              </>
                            )}
                          </div>
                        )}
                      </div>
                    </section>
                  );
                }),
              )}
            </div>
          </div>

          <div className="pointer-events-none absolute left-0 right-0 top-0 h-[32px] bg-gradient-to-b from-white to-transparent" />
        </div>
      </div>

      {/* Правая колонка — не скроллит страницу */}
      <aside className="max-w-[200px] shrink-0 flex-1 px-[10px] py-[20px] pr-[20px] hidden md:block">
        <div className="flex flex-col gap-[5px]">
          <div className="flex gap-[5px] pb-[10px]">
            <div className="w-[10px] shrink-0" />
            <p className="flex-1 font-['Inter',sans-serif] text-[10px] font-bold leading-[1.5] tracking-[-0.11px] text-[#334155]">
              В резюме
            </p>
          </div>

          {workExperience.map((company) => (
            <div key={company.id} className="flex flex-col gap-[5px]">
              <div className="flex gap-[5px]">
                <div className="w-[10px] shrink-0" />
                <p className="flex-1 font-['Inter',sans-serif] text-[10px] font-medium leading-[1.5] tracking-[-0.11px] text-[#334155]">
                  {company.name}
                </p>
              </div>

              {company.positions.map((position) => {
                const isActive = activeSection === position.id;

                return (
                  <button
                    key={position.id}
                    onClick={() => scrollToSection(position.id)}
                    className="flex items-stretch gap-[5px] text-left transition-opacity hover:opacity-70"
                  >
                    {isActive ? (
                      <div className="flex w-[10px] shrink-0 self-stretch items-stretch">
                        <div className="w-[5px] rounded-[2px] bg-[#334155]" />
                      </div>
                    ) : (
                      <div className="w-[10px] shrink-0" />
                    )}

                    <div className="w-[10px] shrink-0" />
                    <p className="flex-1 font-['Inter',sans-serif] text-[8px] font-medium leading-[1.5] tracking-[-0.088px] text-[#334155]">
                      {position.title}
                    </p>
                  </button>
                );
              })}
            </div>
          ))}
        </div>
      </aside>
    </div>
  );
};

export default FullCVPage;
